export enum PurchaseRequisitionStatus {
  OPEN = 'OPEN',
  COMPLETED = 'COMPLETED',
  UNKNOWN = 'UNKNOWN',
  CREATED = 'CREATED',
  ASSIGNED = 'ASSIGNED',
  RESOLVED = 'RESOLVED',
  CANCELLED = 'CANCELLED',
}
